import React, { useState } from 'react'
import Layout from '../../Layout/Layout'
import { CheckIcon, ChevronUpDownIcon, EllipsisVerticalIcon, MagnifyingGlassIcon, PencilSquareIcon, SparklesIcon, TrashIcon } from '@heroicons/react/24/outline'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Switch } from '@headlessui/react'
import Datepicker from 'react-tailwindcss-datepicker'
const initialArticles = [
    {
      "no": 1,
      "id": 2796,
      "title": "Top-Rated Google TV With Dolby Atmos April 2025",
      "date": "1h ago",
      "author": "Aman Tiwari",
      "status": false,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/875592.jpg",
      "summary": "This article highlights a top-rated Google TV available in April 2025, emphasizing its crisp visuals.",
      "category": "Technology"
    },
    {
      "no": 2,
      "id": 2797,
      "title": "The Future of AI in Content Creation",
      "date": "3h ago",
      "author": "Eleanor Smith",
      "status": false,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/352955.jpg",
      "summary": "This article explores the potential future impact of artificial intelligence on the process of content creation.",
      "category": "Technology"
    },
    {
      "no": 3,
      "id": 2798,
      "title": "Mastering React Hooks for Efficient Development",
      "date": "4h ago",
      "author": "David Johnson",
      "status": false,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/83780.jpg",
      "summary": "This article focuses on how to effectively use React Hooks to achieve more efficient development workflows.",
      "category": "Technology"
    },
    {
      "no": 4,
      "id": 2799,
      "title": "Exploring Serverless Architecture Benefits",
      "date": "5h ago",
      "author": "Sarah Williams",
      "status": false,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Jan/221091.jpg",
      "summary": "This article delves into the advantages and benefits of adopting a serverless architecture for applications.",
      "category": "Technology"
    },
    {
      "no": 5,
      "id": 2800,
      "title": "UI/UX Design Principles for Mobile Apps",
      "date": "4/13/25, 01:00 PM",
      "author": "Michael Brown",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/566640.jpg",
      "summary": "This article outlines key UI/UX design principles that are essential for creating effective mobile applications.",
      "category": "Technology"
    },
    {
      "no": 6,
      "id": 2801,
      "title": "Impact of 5G Technology on IoT Devices",
      "date": "4/14/25, 06:30 AM",
      "author": "Jennifer Davis",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/919967.jpg",
      "summary": "This article discusses the significant impact and potential of 5G technology on the functionality and applications of Internet of Things (IoT) devices.",
      "category": "Technology"
    },
    {
      "no": 7,
      "id": 2802,
      "title": "Optimizing Website Performance and Speed",
      "date": "4/15/25, 11:50 AM",
      "author": "Robert Wilson",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/969452.jpg",
      "summary": "This article provides insights and techniques for improving website performance and loading speed.",
      "category": "Technology"
    },
    {
      "no": 8,
      "id": 2803,
      "title": "Fundamentals of Blockchain Technology",
      "date": "4/16/25, 04:20 PM",
      "author": "Linda Garcia",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/968525.jpg",
      "summary": "This article introduces the basic principles and concepts underlying blockchain technology.",
      "category": "Technology"
    },
    {
      "no": 9,
      "id": 2804,
      "title": "Getting Started with Tailwind CSS",
      "date": "4/17/25, 09:10 AM",
      "author": "Christopher Rodriguez",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/220988.jpg",
      "summary": "This article serves as a guide for beginners looking to start using the Tailwind CSS framework.",
      "category": "Technology"
    },
    {
      "no": 10,
      "id": 2805,
      "title": "Role of Data Analytics in Business",
      "date": "4/18/25, 02:40 PM",
      "author": "Angela Martinez",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/601229.jpg",
      "summary": "This article examines the crucial role that data analytics plays in modern business operations and decision-making.",
      "category": "Business"
    },
    {
      "no": 11,
      "id": 2806,
      "title": "Exploring Natural Language Processing",
      "date": "4/19/25, 07:00 AM",
      "author": "Brian Hernandez",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/290077.jpg",
      "summary": "This article provides an overview and explores the concepts within the field of Natural Language Processing (NLP).",
      "category": "Technology"
    },
    {
      "no": 12,
      "id": 2807,
      "title": "Authentication and Authorization in Web Security",
      "date": "4/20/25, 12:20 PM",
      "author": "Nicole Young",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/79985.jpg",
      "summary": "This article discusses the critical aspects of authentication and authorization in the context of web security.",
      "category": "Technology"
    },
    {
      "no": 13,
      "id": 2808,
      "title": "Benefits of TypeScript in Large Projects",
      "date": "4/21/25, 05:55 PM",
      "author": "Kevin Green",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Apr/721446.jpg",
      "summary": "This article outlines the advantages of using TypeScript, particularly in the development of large-scale software projects.",
      "category": "Technology"
    },
    {
      "no": 14,
      "id": 2809,
      "title": "Cloud Computing Service Models",
      "date": "4/22/25, 10:30 AM",
      "author": "Michelle Hall",
      "status": true,
      "imageUrl": "https://images.herzindagi.info/img-affiliate/2025/Mar/765563.jpg",
      "summary": "This article explains the different service models available within cloud computing.",
      "category": "Technology"
    }
]
const people = [
    { id: 1, name: 'Wade Cooper' },
    { id: 2, name: 'Arlene Mccoy' },
    { id: 3, name: 'Devon Webb' },
    { id: 4, name: 'Tom Cook' },
    { id: 5, name: 'Tanya Fox' },
    { id: 6, name: 'Hellen Schmidt' },
    { id: 7, name: 'Caroline Schultz' },
    { id: 8, name: 'Mason Heaney' },
    { id: 9, name: 'Claudie Smitham' },
    { id: 10, name: 'Emil Schaefer' },
]
const categorys = [
    { id: "91", name: "Others" },
    { id: "90", name: "What To Gift" },
    { id: "89", name: "Reading Corner" },
    { id: "88", name: "Fit Zone" },
    { id: "87", name: "Glam and Glamour" },
    { id: "86", name: "Style Vault" },
    { id: "85", name: "Household Furnishings" },
    { id: "84", name: "Gadget Zone" },
    { id: "83", name: "Home Solutions and Electronics" }
]
const status = [
    { id: "1", name: "Active" },
    { id: "2", name: "Inactive" },
]
function ArticleListing() {
    const [articles, setArticles] = useState(initialArticles);
    const handleStatusChange = (id) => {
        setArticles(articles.map(article =>
            article.id === id ? { ...article, status: !article.status } : article
        ));
    };
    // date picker
    const [value, setValue] = useState({ 
        startDate: null, 
        endDate: null
    });
    // dropdown
    const [selectedAuthor, setSelectedAuthor] = useState(people[3]);
    const [selectedCatogry, setSelectedCatogry] = useState(categorys[3]);
    const [selectedStatus, setSelectedStatus] = useState(status[0]);
    return (
        <Layout>
            <div className="px-4 sm:px-6 lg:px-0 max-w-7xl mx-auto">
                <div className="sm:flex sm:items-center py-8">
                    <div className="sm:flex-auto">
                        <h1 className="text-2xl font-bold text-slate-700 inline-flex items-center">Generate Articles with <SparklesIcon aria-hidden="true" className="-ml-0.5 size-5 ms-1 me-1" /> Ai</h1>
                        <p className="mt-2 text-sm font-medium text-slate-500">Automate Content Creation and Boost Your Output.</p>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                        <a
                            href='/ai-article/add-article'
                            className="inline-flex items-center gap-x-2 rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                            >
                            <SparklesIcon aria-hidden="true" className="-ml-0.5 size-5" />
                            Create New Ai Article
                        </a>
                    </div>
                </div>
                <div className='shadow-sm ring-1 ring-gray-300 sm:rounded-lg bg-white'>
                    <div class="grid w-full grid-cols-2 gap-x-2 lg:gap-x-4 gap-y-2 lg:gap-y-4 sm:grid-cols-7 py-4 pt-6 px-6 bg-white border-b border-gray-300 rounded-t-lg">
                        <div class="sm:col-span-1 relative">
                            <label className="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900" > Article ID </label>
                            <input type="text" placeholder='Article ID' className="block w-full rounded-md bg-white px-3 py-2 text-base font-medium text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                        </div>
                        <div class="sm:col-span-1 relative">
                            <label className="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900" > Search </label>
                            <input type="text" placeholder='Search text' className="block w-full rounded-md bg-white px-3 py-2 text-base font-medium text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                        </div>
                        <div class="col-span-2 sm:col-span-1 relative">
                            <label className="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900 z-10" > Select date </label>
                            <div className='border border-gray-300 rounded-md'>
                                <Datepicker
                                    primaryColor={"red"}
                                    value={value} 
                                    onChange={newValue => setValue(newValue)}
                                    showShortcuts={true}
                                    placeholder="Select date..."
                                />
                            </div>
                        </div>
                        <div class="sm:col-span-1 relative">
                            <label className="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900 z-10" > Author </label>
                            <Listbox value={selectedAuthor} onChange={setSelectedAuthor}>
                                <div className="relative">
                                    <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-2 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                    <span className="col-start-1 row-start-1 truncate pr-6">{selectedAuthor.name}</span>
                                    <ChevronUpDownIcon
                                        aria-hidden="true"
                                        className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                    />
                                    </ListboxButton>

                                    <ListboxOptions
                                    transition
                                    className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                    >
                                    {people.map((person) => (
                                        <ListboxOption
                                        key={person.id}
                                        value={person}
                                        className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                                        >
                                        <span className="block truncate font-normal group-data-[selected]:font-semibold">{person.name}</span>

                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                                            <CheckIcon aria-hidden="true" className="size-5" />
                                        </span>
                                        </ListboxOption>
                                    ))}
                                    </ListboxOptions>
                                </div>
                            </Listbox>
                        </div>
                        <div class="sm:col-span-1 relative">
                            <label className="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900 z-10" > Catogry </label>
                            <Listbox value={selectedCatogry} onChange={setSelectedCatogry}>
                                <div className="relative">
                                    <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-2 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                    <span className="col-start-1 row-start-1 truncate pr-6">{selectedCatogry.name}</span>
                                    <ChevronUpDownIcon
                                        aria-hidden="true"
                                        className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                    />
                                    </ListboxButton>

                                    <ListboxOptions
                                    transition
                                    className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                    >
                                    {categorys.map((person) => (
                                        <ListboxOption
                                        key={person.id}
                                        value={person}
                                        className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                                        >
                                        <span className="block truncate font-normal group-data-[selected]:font-semibold">{person.name}</span>

                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                                            <CheckIcon aria-hidden="true" className="size-5" />
                                        </span>
                                        </ListboxOption>
                                    ))}
                                    </ListboxOptions>
                                </div>
                            </Listbox>
                        </div>
                        <div class="sm:col-span-1 relative">
                            <label className="absolute -top-2 left-2 inline-block rounded-lg bg-white px-1 text-xs font-medium text-gray-900 z-10" > Status </label>
                            <Listbox value={selectedStatus} onChange={setSelectedStatus}>
                                <div className="relative">
                                    <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-2 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                    <span className="col-start-1 row-start-1 truncate pr-6">{selectedStatus.name}</span>
                                    <ChevronUpDownIcon
                                        aria-hidden="true"
                                        className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                    />
                                    </ListboxButton>

                                    <ListboxOptions
                                    transition
                                    className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                    >
                                    {status.map((person) => (
                                        <ListboxOption
                                        key={person.id}
                                        value={person}
                                        className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                                        >
                                        <span className="block truncate font-normal group-data-[selected]:font-semibold">{person.name}</span>

                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                                            <CheckIcon aria-hidden="true" className="size-5" />
                                        </span>
                                        </ListboxOption>
                                    ))}
                                    </ListboxOptions>
                                </div>
                            </Listbox>
                        </div>
                        <div class="sm:col-span-1">
                            <button
                                type="button"
                                className="w-full flex justify-center items-center gap-x-2 rounded-md bg-slate-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                                >
                                <MagnifyingGlassIcon aria-hidden="true" className="-ml-0.5 size-5" />
                                Search
                            </button>
                        </div>
                    </div>
                    <ul role="list" className="divide-y divide-gray-100">
                        {articles.map((article) => (
                            <li key={article.no} className="flex justify-between gap-x-2 lg:gap-x-6 py-4 px-4">
                                <div className="flex min-w-0 gap-x-4">
                                    {/* <img alt="" src={article.imageUrl} className="w-20 lg:w-32 h-12 lg:h-16 flex-none rounded-md bg-gray-50" /> */}
                                    <div className="min-w-0 flex-auto ps-1">
                                        <p className="text-[12px]/4 lg:text-lg/6 font-semibold text-slate-600">
                                            {article.title}
                                        </p>
                                        <p className="mt-1 hidden lg:flex text-xs/5 font-medium text-slate-400">
                                            {article.summary}
                                        </p>
                                        <p className="text-[9px]/5 uppercase text-red-500">
                                            {article.category}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex shrink-0 flex-col lg:flex-row items-center gap-x-6">
                                    <div className="hidden sm:flex sm:flex-col sm:items-end">
                                        <p className="text-sm/6 font-medium text-slate-600">{article.author}</p>
                                        <p className="mt-1 text-xs/5 font-medium text-slate-400"> Last seen <time dateTime={article.date}>{article.date}</time> </p>
                                    </div>
                                    <Switch checked={article.status} onChange={() => handleStatusChange(article.id)} className={`group relative inline-flex h-5 lg:h-5 w-7 lg:w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-slate-600 focus:ring-offset-2 ${ article.status ? 'bg-slate-600' : 'bg-gray-200' }`} >
                                        <span className="sr-only">Use setting</span>
                                        <span aria-hidden="true" className="pointer-events-none absolute size-full rounded-md bg-white" />
                                        <span aria-hidden="true" className={`pointer-events-none absolute mx-auto h-3 lg:h-4 w-7 lg:w-9 rounded-full transition-colors duration-200 ease-in-out ${ article.status ? 'bg-slate-600' : 'bg-gray-200' }`} />
                                        <span aria-hidden="true" className={`pointer-events-none absolute left-0 inline-block size-4 lg:size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out ${ article.status ? 'translate-x-3 lg:translate-x-5' : 'translate-x-0' }`} />
                                    </Switch>
                                    <Menu as="div" className="relative flex-none">
                                        <MenuButton className="-m-2.5 block p-2.5 mt-1 lg:mt-0 text-gray-500 hover:text-gray-900">
                                            <span className="sr-only">Open options</span>
                                            <EllipsisVerticalIcon aria-hidden="true" className="size-5" />
                                        </MenuButton>
                                        <MenuItems transition className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in" >
                                            <MenuItem>
                                                <a href="#" className="flex items-center px-3 py-1 text-[12px]/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none" ><PencilSquareIcon className='h-4 w-4 me-1' /> Edit </a>
                                            </MenuItem>
                                            <MenuItem>
                                                <a href="#" className="flex items-center px-3 py-1 text-[12px]/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none" ><TrashIcon className='h-4 w-4 me-1' /> Delete </a>
                                            </MenuItem>
                                        </MenuItems>
                                    </Menu>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </Layout>
    )
}

export default ArticleListing
